export const CATEGORY_ICONS = {
    'hardware-chip': '💻',
    'phone-portrait': '📱',
    'car': '🚗',
    'shirt': '👕',
    'sparkles': '✨',
    'heart': '❤️',
    'restaurant': '🍴',
    'business': '🏢',
    'home': '🏠',
    'paw': '🐾',
    'construct': '🔧',
    'laptop': '💻',
    'tv': '📺',
    'ear': '🎧',
    'map': '🗺️',
    'leaf': '🍃',
    'phone': '📱',
    'electronics': '🔌',
    'fashion': '👗',
    'beauty': '💄',
    'sports': '⚽',
    'books': '📚',
    'food': '🍕',
    'health': '🏥',
    'garden': '🌻',
    'toys': '🧸',
    'jewelry': '💎',
    'tools': '🔨',
  };
  
  export const getCategoryIcon = (iconName) => {
    return CATEGORY_ICONS[iconName] || '📦';
  };